import { FC } from 'react';
import { EditorContent, Editor } from '@tiptap/react'
import SelectedMenu from '../SelectedMenu';

interface IEditor {
  editor: Editor;
  togglePreventClose: (value: boolean) => void;
}

const EditorComponent: FC<IEditor> = ({ editor, togglePreventClose }) => {
  if (!editor) return null;

  return (
    <>
      <EditorContent editor={editor} />
      <SelectedMenu editor={editor} togglePreventClose={togglePreventClose} />
    </>
  );
};

export default EditorComponent;
